import React from 'react';

import { Quote, Star } from 'lucide-react';

import { TestimonialData } from '../types/types';
import AMPImage from './AMPImage';

const testimonials: TestimonialData[] = [
  {
    id: 1,
    name: 'Carlos Rodríguez',
    position: 'Gerente de Operaciones',
    company: 'Industrias Metalúrgicas del Sur',
    content:
      'La implementación del sistema de automatización superó nuestras expectativas. La productividad aumentó significativamente y el ROI se alcanzó en menos tiempo del esperado.',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80',
  },
  {
    id: 2,
    name: 'María González',
    position: 'CEO',
    company: 'TechPyme Chile',
    content:
      'El equipo de Prime JC demostró un profundo conocimiento en transformación empresarial. Su solución nos ayudó a optimizar procesos y reducir costos operativos.',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80',
  },
  {
    id: 3,
    name: 'Roberto Sánchez',
    position: 'Director de Innovación',
    company: 'Minera del Norte',
    content:
      'La implementación de soluciones de IA ha transformado nuestra operación minera. La precisión en el análisis de datos y la predicción de mantenimiento son excepcionales.',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80',
  },
];

interface TestimonialsProps {
  className?: string;
}

function Testimonials({ className = '' }: TestimonialsProps) {
  return (
    <section className={`py-12 bg-gray-50 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">Lo que dicen nuestros clientes</h2>
          <p className="mt-4 text-xl text-gray-600">
            Testimonios de empresas que han transformado sus operaciones con nuestras soluciones
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map(testimonial => (
            <div
              key={testimonial.id}
              className="bg-white rounded-lg shadow-lg p-6 transform hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center mb-4">
                <AMPImage
                  src={testimonial.image}
                  alt={testimonial.name}
                  width={48}
                  height={48}
                  className="w-12 h-12 rounded-full mr-4"
                  layout="fixed"
                />
                <div>
                  <h3 className="font-semibold text-gray-900">{testimonial.name}</h3>
                  <p className="text-sm text-gray-600">{testimonial.position}</p>
                  <p className="text-sm text-gray-500">{testimonial.company}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>

              <Quote className="h-8 w-8 text-blue-600 mb-4" />

              <p className="text-gray-600 italic">"{testimonial.content}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
